// Mapeo centralizado de tipo de bloque -> icono nuevo (assets/images/blocks/Bloque_*.svg).
// Los nombres nuevos no siguen la regla vieja (modulo_<compo>), por eso se mapea explicitamente.
// Para tipos no mapeados (ej. bloques de loyalty) se cae al fallback con la regla vieja modulo_*.

const ICON_BY_DRAGICON = {
  Lead: 'Bloque_Leads.svg',
}

const ICON_BY_COMPO = {
  editTitulo: 'Bloque_Title.svg',
  editParrafo: 'Bloque_Paragraph.svg',
  editParrafo_new: 'Bloque_Paragraph.svg',
  editBoton: 'Bloque_Button.svg',
  editSpace: 'Bloque_Space.svg',
  editImagen: 'Bloque_Image.svg',
  editSocial: 'Bloque_social.svg',
  editAvatar: 'Bloque_Avatar.svg',
  editLine: 'Bloque_Line.svg',
  editVideo: 'Bloque_Video.svg',
  editUbicacion: 'Bloque_Ubicacion.svg',
  editHTML: 'Bloque_HTML.svg',
  editQRCode: 'Bloque_QR.svg',
  editSaveDate: 'Bloque_Agendar.svg',
  editFlags: 'Bloque_Icons.svg',
}

function mappedFile(element) {
  if (!element) return null
  if (element.dragIcon && ICON_BY_DRAGICON[element.dragIcon]) return ICON_BY_DRAGICON[element.dragIcon]
  if (element.compo && ICON_BY_COMPO[element.compo]) return ICON_BY_COMPO[element.compo]
  return null
}

/**
 * Devuelve el src (require) del icono de un bloque del editor.
 * Usa el set nuevo Bloque_*.svg si esta mapeado; si no, cae a la regla vieja modulo_*.
 */
export function blockIconSrc(element) {
  const file = mappedFile(element)
  if (file) return require('@/assets/images/blocks/' + file)

  // Fallback: regla vieja modulo_* (casos especiales loyalty + generico)
  if (element && element.compo === 'editPremio') return require('@/assets/images/blocks/modulo_Reward.svg')
  if (element && element.compo === 'editBeneficio') return require('@/assets/images/blocks/modulo_Benefit.svg')
  if (element && element.dragIcon) return require('@/assets/images/blocks/modulo_' + element.dragIcon.replace('edit', '') + '.svg')
  if (element && element.compo) return require('@/assets/images/blocks/modulo_' + element.compo.replace('edit', '') + '.svg')
  return require('@/assets/images/blocks/modulo_Titulo.svg')
}
